export const userIdState = (state) => state.ui.userId;
//# sourceMappingURL=UserIdState.js.map